<template>
  <svg v-if="props.name === 'icon-sort-up'" class="hcl-icon-svg inline" viewBox="0 7 24 24">
    <path fill="currentColor" d="M7,15L12,10L17,15H7Z" />
  </svg>
  <svg v-else-if="props.name === 'icon-sort-down'" class="hcl-icon-svg inline" viewBox="0 0 24 21">
    <path fill="currentColor" d="M7,10L12,15L17,10H7Z" />
  </svg>
  <svg v-else-if="props.name === 'icon-sort-none'" class="hcl-icon-svg inline" viewBox="0 2 24 24">
    <path fill="currentColor"
      d="M12,3.5L6,9.5V11H18V9.5L12,3.5M12,6.33L14.67,9H9.33L12,6.33M6,13V14.5L12,20.5L18,14.5V13H6M9.33,15H14.67L12,17.67L9.33,15Z" />
  </svg>
</template>

<script setup lang="ts">
interface Props {
  /**
   * Definition as an JS object.
   */
  name: string
}

const props = withDefaults(defineProps<Props>(), {
  name: ''
})
</script>
